module.exports = __webpack_public_path__ + "static/img/5.15b1275.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/4/1/12/zh/5.png
// module id = spIM
// module chunks = 0